<template>
  <FreezeHeader v-if="displayFreezeHeader" />
  <PromoHeader v-if="displayPromoHeader" />
  <BaseHeader v-bind="$attrs" />
</template>

<script setup lang="ts">
import PromoHeader from './PromoHeader.vue';
import FreezeHeader from './FreezeHeader.vue';
import BaseHeader from '#layers/core/app/components/domain/Layout/AppHeader.vue';

const route = useRoute();
const isOnLandingPage = computed(() => route.meta.isHomePage);

const { isPromoActive } = usePromos();
const { isOnFreezePeriod } = useFreezePeriod();
const displayFreezeHeader = computed(() => isOnLandingPage.value && isOnFreezePeriod);
const displayPromoHeader = computed(() => isOnLandingPage.value && isPromoActive.value);
</script>
